import { createContext, useContext, useState } from "react"

const Context = createContext()

export function useAuth() {
    if (!Context) {
        throw new Error("Component not wrapped in context")
    }
    return useContext(Context)
}

export function AuthProvider({ children }) {
    const [auth, setAuth] = useState({})
    const [persist, setPersist] = useState(
        JSON.parse(localStorage.getItem("persist")) || false
    )
    const [authError, setAuthError] = useState(null)

    function removeAuth() {
        setAuth({ token: null, logout: true })
        setAuthError(null) // Clear error on logout
    }

    return (
        <Context.Provider
            value={{
                auth,
                setAuth,
                removeAuth,
                persist,
                setPersist,
                authError,
                setAuthError,
            }}
        >
            {children}
        </Context.Provider>
    )
}
